module.exports = __webpack_public_path__ + "four2.jpg?db958c53744ad5d9c5d196d0212b538b";